import BaseForm from 'base-components/BaseForm/BaseForm';
import nova from 'logo.svg';
import { PropsWithChildren } from 'react';
import { DefaultValues, FieldValues } from 'react-hook-form';
import { Card, CardBody } from 'reactstrap';
import 'scss/Main.scss';
import './Window.scss';

export type WindowProps<T extends FieldValues> = PropsWithChildren<{
    onSubmit: (data: T) => void;
    label: string;
    defaultValues: DefaultValues<T>;
}>;

const Window = <T extends FieldValues>({ children, label, onSubmit, defaultValues }: WindowProps<T>) => {
    return (
        <Card className="main-card window">
            <CardBody className="flex-centered window__card-body">
                <div className="window__logo flex-centered">
                    <img src={nova} alt="Nova Horizontal SVG" />
                </div>
                <BaseForm<T>
                    clearAfterSubmit={false}
                    onSubmit={onSubmit}
                    className="window__content"
                    defaultValues={defaultValues}
                >
                    <div className="window__label">{label}</div>
                    {children}
                </BaseForm>
            </CardBody>
        </Card>
    );
};

export default Window;
